import {Component, Input, ViewChild} from '@angular/core';
import {AbstractControl, UntypedFormGroup} from '@angular/forms';
import {ProfileImageSelectorComponent} from '../../profile-image-selector/profile-image-selector.component';

@Component({
    selector: 'app-giver-profile',
    templateUrl: './giver-profile.component.html',
    styleUrls: ['./giver-profile.component.scss'],
    standalone: false
})
export class GiverProfileComponent {
    @Input() parentGroup: UntypedFormGroup;

    @ViewChild('profileImageSelector')
    profileImageSelector: ProfileImageSelectorComponent;

    avatars = [
        'assets/images/profil-thumbnail-1.svg',
        'assets/images/profil-thumbnail-2.svg',
        'assets/images/profil-thumbnail-3.svg',
        'assets/images/profil-thumbnail-4.svg',
    ];

    constructor() {
    }

    get profileImage(): string {
        return this.parentGroup.get('profileImage').value;
    }

    get customProfileImage(): any {
        return this.parentGroup.get('customProfileImage').value;
    }

    get firstControl(): AbstractControl {
        return this.parentGroup.controls.first;
    }

    get nameControl(): AbstractControl {
        return this.parentGroup.get('name');
    }

    get profileImageControl(): AbstractControl {
        return this.parentGroup.get('profileImage');
    }

    get aboutMe(): AbstractControl {
        return this.parentGroup.get('aboutMe');
    }

    setAvatar(s: string) {
        this.parentGroup.get('profileImage').setValue(s);
        this.parentGroup.get('profileImage').markAsDirty();
        this.parentGroup.get('customProfileImage').reset('');
        this.parentGroup.get('customProfileImage').markAsDirty();
    }

    setCustomProfileImage(s: string) {
        this.parentGroup.get('profileImage').setValue(s);
        this.parentGroup.get('profileImage').markAsDirty();
        this.parentGroup.get('customProfileImage').setValue(s);
        this.parentGroup.get('customProfileImage').markAsDirty();
    }

    async croppedImage(): Promise<any> {
        return await this.profileImageSelector.croppedImage();
    }

}
